module.exports = __webpack_public_path__ + "img/hub71_logo.9a1f425c.svg";